import React from "react";
import PropTypes from "prop-types";
import StatusIcon from "../../../common/StatusIcon";
import { Link } from "react-router-dom";
import { customers } from "../../../../locales/en";
import { CLIENT_DETAILS } from "../../../../route/paths";
import { formatDateWithDayjs } from "../../../../utils/utils";

const FullNameCell = ({ row }) => {
  const { firstName, lastName, id, deletedAt, middleName } = row.original;
  const fullName = middleName
    ? `${firstName} ${middleName} ${lastName}`
    : `${firstName} ${lastName}`;

  if (deletedAt) {
    return fullName;
  }

  return (
    <Link title={customers.goTouser} to={CLIENT_DETAILS(id)}>
      {fullName}
    </Link>
  );
};
FullNameCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      middleName: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      deletedAt: PropTypes.any
    }).isRequired
  }).isRequired
};

const ConfirmedCell = ({ value }) => {
  return <StatusIcon value={value} />;
};
ConfirmedCell.propTypes = {
  value: PropTypes.bool
};

const LastUpdatedCell = ({ row }) => {
  const { updatedAt, createdAt } = row.original;
  const displayDate = updatedAt ?? createdAt;
  return formatDateWithDayjs(displayDate);
};

const LastCreatedCell = ({ row }) => {
  const { createdAt } = row.original;
  const displayDate = createdAt;
  return formatDateWithDayjs(displayDate);
};
LastCreatedCell.propTypes = {
  row: PropTypes.shape({
    createdAt: PropTypes.string
  }).isRequired
};
LastUpdatedCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      updatedAt: PropTypes.string,
      createdAt: PropTypes.string
    }).isRequired
  }).isRequired
};

export const COLUMNS = [
  {
    Header: "ID",
    Footer: "ID",
    accessor: "id"
  },
  {
    Header: "Full Name",
    Footer: "Full Name",
    accessor: "fullname",
    Cell: FullNameCell
  },
  {
    Header: "Email Address",
    Footer: "Email Address",
    accessor: "primaryEmail"
  },
  {
    Header: "Email Confirmed",
    Footer: "Email Confirmed",
    accessor: "isConfirmed",
    Cell: ConfirmedCell
  },
  {
    Header: "Roles",
    Footer: "Roles",
    accessor: "roles"
  },
  {
    Header: "Created At",
    Footer: "Created At",
    accessor: "createdAt",
    Cell: LastCreatedCell
  },
  {
    Header: "Last Updated At",
    Footer: "Last Updated At",
    accessor: "updatedAt",
    Cell: LastUpdatedCell
  }
];
